import { CommonModule } from "@angular/common";
import { Component, OnInit } from '@angular/core';
import { ApiCallsService } from '../../../shared/services/api-calls.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from "@angular/forms";
import { ToastService } from "../../../shared/services/toast.service";
import { bulkactions } from "./bulkactions";

interface Site {
  site_id: string;
  site_name: string;
}

@Component({
  selector: 'app-bulk-action-create',
  imports: [CommonModule, NgbModule, FormsModule],
  templateUrl: './bulk-action-create.component.html',
  styleUrls: ['./bulk-action-create.component.scss']
})
export class BulkActionCreateComponent implements OnInit {
  [key: string]: any;   // ← FIXES THE ERROR
  commandConfig: any = {}

  sites: Site[] = [];
  commandList:any[] =[];
  searchTerm = '';
  siteId: string = '';
  selectedValue:string = '';
  internalOptions: Site[] = [];
  towerlist: any[] = [];
  MeterMakelist: any[] = [];
  siteloadlistfrom: any[] = [];
  siteloadlistto: any[] = [];
  private _selectedCommand: string = '';
  formValues: { [key: string]: any } = {};
  constructor(private apiservice: ApiCallsService,private toast: ToastService) {}
get selectedCommand(): string {
  return this._selectedCommand;
}
formData = new FormData();

set selectedCommand(value: string) {
  this._selectedCommand = value;
  this.searchTerm =''
  // 👉 Clear other variables when command changes
  this.siteId = '';
  this.towerlist = []
  this.MeterMakelist = []
  this.siteloadlistfrom = []
  this.siteloadlistto = []
  console.log('Command changed to:', value);
}
  ngOnInit(): void {
    this.commandConfig = bulkactions
    this.loadSites();
    this.loadCommandList();
  }

  loadCommandList(): void {
    this.apiservice.BulkCommands().subscribe(res=>{
      this.commandList = res.Data
    })
  }

  loadSites(): void {
    this.apiservice.getSiteList().subscribe(data => {
      this.internalOptions = data.Data.list;
    });
  }
  loadTowerList():void{
    this.apiservice.towerlist(this.siteId).subscribe(res=>{
      this.towerlist = res.Data
    })
  }
    loadMeterMakeList():void{
    this.apiservice.MeterMakelist(this.siteId).subscribe(res=>{
      this.MeterMakelist = res.Data
    })
  }
  loadSiteLoadList():void{
    this.apiservice.siteloadtypelist(this.siteId).subscribe(res=>{

      this.siteloadlistfrom = res.Data
      this.siteloadlistto = res.Data
      console.log(this.siteloadlistfrom);
      
    })
  }
  get filteredItems(): Site[] {
    if (!this.internalOptions.length) return [];
    if (!this.searchTerm.trim()) return this.internalOptions;

    const lower = this.searchTerm.toLowerCase();
    return this.internalOptions.filter(site =>
      site.site_name.toLowerCase().includes(lower)
    );
  }

  selectOption(site: Site) {
    this.searchTerm = site.site_name;   // 👈 input box me selected naam dikhega
    this.siteId = site.site_id;  // 👈 selected id rakhega
    this.loadTowerList();
    if (this.selectedCommand === 'Bulk Site Load Type Change') {
      this.loadSiteLoadList();
    }
    if (this.selectedCommand === 'Bulk Meter Make') {
      this.loadMeterMakeList();
    }
  }

  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.searchTerm = input.value;
    this.selectedValue = '';  // 👈 input edit kare to selected id reset
  }
  isArray(value: any): boolean {
  return Array.isArray(value);
}


submitForm() {
  const config = this.commandConfig[this.selectedCommand];

  if (!config) {
    console.warn("No form selected");
    return;
  }

  const payload: any = {};

  // Loop through the fields of this selected form
  config.fields.forEach((f:any) => {
    payload[f.formKey] = this.formValues[f.model] ?? '';
  });

  console.log("Final Payload:", payload);

  // If you want FormData instead of JSON:
  const formData = new FormData();
  Object.keys(payload).forEach(k => formData.append(k, payload[k]));
  formData.append('site_id',this.siteId)
  console.log("Final FormData:");
  for (let p of formData.entries()) {
    console.log(p[0], p[1]);
  }

  // Call the submit function defined in JSON
  this.apiservice.BulkCommandSubmit(formData,config.submit).subscribe(res=>{
    console.log(res);
  })
}



}
